import type { ReactNode } from 'react';
import { PencilIcon, PlusIcon } from '@heroicons/react/24/outline';

interface ComposerSpineRowProps {
    /** 'add' for the always-available "+ Interaction" flow, 'edit' when swapping an existing card for the composer in place. */
    mode: 'add' | 'edit';
    /** Only 'edit' (replacing a specific entry mid-list) ever needs a trailing connector, and only when that entry wasn't the last one. */
    showConnector: boolean;
    children: ReactNode;
}

// The composer's spine node - a dark rounded-square, not a channel medallion
// (no channel is "the" channel until saved). Shared by "add" and "edit".
export function ComposerSpineRow({ mode, showConnector, children }: ComposerSpineRowProps) {
    const Icon = mode === 'edit' ? PencilIcon : PlusIcon;
    return (
        <div className="flex gap-4">
            <div className="flex flex-col items-center shrink-0 w-10">
                <span className="w-10 h-10 rounded-xl bg-gray-900 text-white flex items-center justify-center shrink-0">
                    <Icon className="h-4 w-4" />
                </span>
                {showConnector && <span className="flex-1 w-px bg-gray-200 mt-2" />}
            </div>
            <div className="flex-1 min-w-0 pb-5">{children}</div>
        </div>
    );
}
